import React from 'react';

import { colors } from 'global/colors';
import { StyledBaseRating, RatingStar } from './styles';

export default function Rating({ rating, onChange, size, color, fractions, ...props }) {
  return (
    <StyledBaseRating
      fractions={fractions || 2}
      placeholderRating={1} // For some reason having placeholderRating at 0 will not work properly...
      initialRating={rating}
      onClick={onChange}
      placeholderSymbol={<RatingStar size={size} color={colors.gray} />}
      emptySymbol={<RatingStar size={size} color={colors.gray} />}
      fullSymbol={<RatingStar size={size} color={color ? color : colors.fsDarkBlue} />}
      {...props}
    />
  );
}
